import {
  Button,
  HStack,
  Icon,
  Text,
  useDisclosure,
  VStack,
  Wrap,
  WrapItem,
  WrapProps,
} from "@chakra-ui/react";
import { RiEdit2Line } from "@remixicon/react";
import { lazy, Suspense, useState } from "react";
import { RiDeleteBinLine } from "react-icons/ri";
import { ProductVariantInterface } from "../../constants/Product";
import useCustomToast from "../../lib/useCustomToast";
import { CardVariant } from "../../pages/dashboard/supplier/CardVariant";
import { useProductVariantStore } from "../../store/useProductVariantStore";
import { axiosSupplier } from "../../utils/AxiosInstance";
import { SpinnerLoading } from "../spinner/SpinnerLoading";

const InputVariantModal = lazy(
  () => import("../../pages/dashboard/supplier/InputVariantModal")
);
const ConfirmationModal = lazy(() => import("../modal/ConfirmationModal"));

interface Props extends WrapProps {}

export const ListTempVariant = ({ ...rest }: Props) => {
  const [selectedVariant, setSelectedVariant] = useState<
    ProductVariantInterface | undefined
  >(undefined);
  const [loading, setLoading] = useState<boolean>(false);
  const toast = useCustomToast();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: isOpenVariant,
    onOpen: onOpenVariant,
    onClose: onCloseVariant,
  } = useDisclosure();

  const { variants, removeVariant } = useProductVariantStore();

  const openVariantModal = (variantId: any) => {
    const select = variants.find((v: any) => v.tempId === variantId);
    setSelectedVariant(select);
    onOpenVariant();
  };

  const openDeleteModal = (variantId: any) => {
    const select = variants.find((v: any) => v.tempId === variantId);
    setSelectedVariant(select);
    onOpen();
  };

  const deleteVariant = () => {
    if (!!selectedVariant?.pivot?.product_id) {
      setLoading(true);

      axiosSupplier
        .delete(
          `/v1/supplier/product/delete-variant/${selectedVariant.pivot?.product_id}/${selectedVariant.pivot?.variant_id}`
        )
        .then((res) => {
          toast({
            title: res.data.message,
            status: "success",
          });
          removeVariant(selectedVariant.tempId);
          onClose();
        })
        .catch((err) => {
          toast({
            description: err?.response?.data?.message || "",
          });
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      removeVariant(selectedVariant?.tempId);
      onClose();
    }
  };

  return (
    <>
      <Wrap w={"100%"} px={2} spacing={4} {...rest}>
        {variants.map((item, i) => (
          <WrapItem w={"100%"} key={i}>
            <VStack w={"100%"} gap={1} align={"stretch"}>
              <Text textStyle={"b-reg-sb"}>{`Varian ${i + 1}`}</Text>

              <CardVariant data={item} />

              <HStack>
                <Button
                  w={"fit-content"}
                  variant={"ghost"}
                  size={"sm"}
                  colorScheme="yellow"
                  leftIcon={<Icon as={RiEdit2Line} />}
                  onClick={() => openVariantModal(item.tempId)}
                >
                  Edit
                </Button>

                <Button
                  w={"fit-content"}
                  variant={"ghost"}
                  size={"sm"}
                  colorScheme="red"
                  leftIcon={<Icon as={RiDeleteBinLine} />}
                  onClick={() => openDeleteModal(item.tempId)}
                >
                  Hapus
                </Button>
              </HStack>
            </VStack>
          </WrapItem>
        ))}
      </Wrap>

      <Suspense fallback={<SpinnerLoading />}>
        <ConfirmationModal
          isOpen={isOpen}
          onOpen={onOpen}
          onClose={onClose}
          title="Hapus Produk"
          subtitle="Apakah anda yakin ingin menghapus produk ini?"
          btnText="Hapus"
          onClickSubmit={() => {
            deleteVariant();
          }}
          loading={loading}
          children={undefined}
        />
      </Suspense>

      <Suspense fallback={<SpinnerLoading />}>
        <InputVariantModal
          isOpen={isOpenVariant}
          onOpen={onOpenVariant}
          onClose={onCloseVariant}
          data={selectedVariant}
          title="Ubah Varian"
          children={undefined}
        />
      </Suspense>
    </>
  );
};
